import { render, staticRenderFns } from "./SessionsRegistrationPage.vue?vue&type=template&id=37785a96"
import script from "./SessionsRegistrationPage.vue?vue&type=script&lang=js"
export * from "./SessionsRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports